module.exports = __webpack_public_path__ + "img/a.0b310994.jpg";